import { render, staticRenderFns } from "./fccAbaSolicitacaoEspecial.vue?vue&type=template&id=d05c5b40"
import script from "./fccAbaSolicitacaoEspecial.vue?vue&type=script&lang=js"
export * from "./fccAbaSolicitacaoEspecial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports